<template>
  <v-app
    :class="{
      'anonymous-background': is_anonymous,
      'pattern-background': $route.meta.isRegistration
    }"
  >
    <registration-navigation-drawer
      v-if="$route.meta.isRegistration && $vuetify.breakpoint.lgAndUp"
    ></registration-navigation-drawer>
    <app-bar v-else></app-bar>
    <v-main>
      <router-view />
    </v-main>
    <alert ref="alert"></alert>
    <confirm ref="confirm"></confirm>
    <v-snackbar
      ref="snackbar"
      v-model="snackbar"
      timeout="5000"
      :color="snackbarColor"
      top
      class="font-weight-bold"
    >
      <v-icon dark v-if="snackbarIcon">
        {{ snackbarIcon }}
      </v-icon>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import AppBar from "@/components/layout/AppBar";
import Alert from "@/components/layout/Alert";
import Confirm from "@/components/layout/Confirm";
import RegistrationNavigationDrawer from "@/components/common/RegistrationNavigationDrawer";
export default {
  name: "App",
  components: {
    "app-bar": AppBar,
    alert: Alert,
    confirm: Confirm,
    RegistrationNavigationDrawer
  },
  data: () => ({
    snackbar: false,
    snackbarColor: "success",
    snackbarText: "",
    snackbarIcon: ""
  }),
  computed: mapGetters({
    is_anonymous: "survey/is_anonymous"
  }),
  methods: {
    openSnackbar(text, color, icon) {
      this.snackbarText = text;
      this.snackbarColor = color || "success";
      this.snackbar = true;
      this.snackbarIcon = icon;
    },
    openSnackbarSuccess(text) {
      this.openSnackbar(text, "success", "check-circle");
    },
    openSnackbarError(text) {
      this.openSnackbar(text, "error", "cancel");
    }
  },
  mounted() {
    this.$root.$alert = this.$refs.alert.open;
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$snackbar = this.openSnackbar;
    this.$root.$snackbarSuccess = this.openSnackbarSuccess;
    this.$root.$snackbarError = this.openSnackbarError;
  }
};
</script>

<style lang="scss">
@import "src/scss/main.scss";

.anonymous-background {
  .v-application--wrap {
    background-image: url("https://res.cloudinary.com/dlw64o4rf/image/upload/v1616509378/web%20images/cc-anonymous-background_mptiln.svg");
    background-repeat: repeat;
    background-size: 100px;
  }
}

.pattern-background {
  .v-main__wrap {
    background-image: url(https://res.cloudinary.com/dlw64o4rf/image/upload/v1621970167/Front/cc-vertical-pattern_jyvelh.svg);
    background-repeat: repeat-y;
  }
}
</style>
